import { render, staticRenderFns } from "./RuleGoChat.vue?vue&type=template&id=078d0d90"
import script from "./RuleGoChat.vue?vue&type=script&lang=js"
export * from "./RuleGoChat.vue?vue&type=script&lang=js"
import style0 from "./RuleGoChat.vue?vue&type=style&index=0&id=078d0d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports